var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2680_4765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10C7 9.44771 7.44772 9 8 9H13C13.5523 9 14 9.44771 14 10C14 10.5523 13.5523 11 13 11H8C7.44772 11 7 10.5523 7 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10C17 10.5523 16.5523 11 16 11C15.4477 11 15 10.5523 15 10C15 9.44771 15.4477 9 16 9C16.5523 9 17 9.44771 17 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15C16.5523 15 17 14.5523 17 14C17 13.4477 16.5523 13 16 13C15.4477 13 15 13.4477 15 14C15 14.5523 15.4477 15 16 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3673 2.56085C9.87528 1.63289 10.863 1 12 1C13.137 1 14.1247 1.63289 14.6327 2.56085C14.7281 2.73504 14.8316 2.86635 14.9211 2.94311C14.9676 2.98294 14.9953 2.99616 15.0061 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H8.99386C9.00472 2.99616 9.03245 2.98294 9.07889 2.94311C9.16839 2.86635 9.27195 2.73504 9.3673 2.56085ZM12 3C11.6228 3 11.2928 3.20846 11.1216 3.52121C10.9518 3.83147 10.7093 4.17964 10.3809 4.46126C10.0474 4.74723 9.58037 5 9 5H8C6.34315 5 5 6.34315 5 8V16C5 17.6569 6.34315 19 8 19H16C17.6569 19 19 17.6569 19 16V8C19 6.34315 17.6569 5 16 5H15C14.4196 5 13.9526 4.74723 13.6191 4.46126C13.2907 4.17964 13.0482 3.83147 12.8784 3.52121C12.7072 3.20846 12.3772 3 12 3ZM8.98855 3.00135C8.98856 3.00121 8.98994 3.00076 8.99263 3.00042L8.9901 3.00115L8.98855 3.00135C8.98854 3.00139 8.98831 3.00138 8.98855 3.00135ZM15.0112 3.00139C15.011 3.00135 15.0104 3.00126 15.01 3.00117C15.0093 3.00102 15.0085 3.00078 15.0074 3.00042C15.0101 3.00076 15.0112 3.00125 15.0112 3.00139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2680_4765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.6347e6d059a397f92c5cf11d545b479d.svg";
export { ForwardRef as ReactComponent };